const AGENT_TYPES = [
  { label: 'TEAM_LEADER', value: 'TEAM_LEADER' },
  { label: 'SENIOR_AGENT', value: 'SENIOR_AGENT' },
  { label: 'AGENT', value: 'AGENT' },
  { label: 'TRAINEE_AGENT', value: 'TRAINEE_AGENT' }
]

export default AGENT_TYPES